import { Bootgrid } from "./bootgrid";
import { AdvancedFilterManager } from "./AdvancedFilter/advancedFilterManager";

export function initAdvancedFilter(this: Bootgrid) {
    if (!this.container.querySelector(".advanced-filter-toggle-button")) {
        renderAdvancedFilterToggleButton.call(this);
    }
    if (this.$bootgrid.parent().find("#advanced-search").length === 0) {
        this.advancedFilterManagerContainer = document.createElement("div");
        this.advancedFilterManagerContainer.classList.add("bootgrid-header", "mx-3", "bootgrid-advanced-search");

        this.container.querySelector(".bootgrid-header").insertAdjacentElement("afterend", this.advancedFilterManagerContainer);
        this.advancedFilterManager = new AdvancedFilterManager(this.advancedFilterManagerContainer, {
            columns: (this.$bootgrid as any).bootgrid("getColumnSettings"),
            filters: this.bootgridState.AdvancedFilters,
            onSubmit: () => this.reloadTable(),
            onStateChange: () => this.stateChangeHandler(),
        });
    }
    this.advancedFilterManager.render();
}

export function renderAdvancedFilterToggleButton(this: Bootgrid) {
    const constructFilterToggleButton = (): HTMLButtonElement => {
        const actionButtonsContainer = this.container.querySelector(".actionBar-left") as HTMLElement;
        var btn = document.createElement("button");
        btn.classList.add("btn", "btn-outline-secondary", "text-dark", "d-flex", "gap-1", "align-items-center", "advanced-filter-toggle-button");
        if (this.bootgridState.AdvancedFilters) {
            btn.classList.add("active");
        }
        btn.setAttribute("type", "button");
        btn.setAttribute("title", "Toggle Filters");
        var icon = document.createElement("i");
        icon.classList.add("fa", "fa-filter");
        icon.ariaHidden = "true";
        btn.appendChild(icon);
        var iconText = document.createElement("span");
        iconText.classList.add("hidden-sm", "hidden-xs");
        iconText.innerHTML = this.config.translations.captionActionAdvancedFilters;
        btn.appendChild(iconText);
        actionButtonsContainer.appendChild(btn);

        return btn;
    };

    const toggleButton = constructFilterToggleButton();

    toggleButton.addEventListener("click", (e: MouseEvent) => {
        e.preventDefault();
        toggleAdvancedFilter.call(this);
    });
}

export function applyAdvancedFilterState(this: Bootgrid) {
    setAdvancedFilterVisibility.call(this);
}

export function setAdvancedFilterVisibility(this: Bootgrid) {
    const isCollapsed = (this.bootgridState.IsAdvancedSearchCollapsed ?? false) && !(this.bootgridState.AdvancedFilters?.length > 0);
    if (isCollapsed !== this.advancedFilterManagerContainer.classList.contains("d-none")) {
        toggleAdvancedFilter.call(this);
    }
}

export function toggleAdvancedFilter(this: Bootgrid) {
    this.advancedFilterManagerContainer.classList.toggle("d-none");
    this.container.querySelector(".advanced-filter-toggle-button").classList.toggle("active");
}
